import { render, staticRenderFns } from "./ModalDetallesSolicitudesPagosAgrupados.vue?vue&type=template&id=6b874dc2"
import script from "./ModalDetallesSolicitudesPagosAgrupados.vue?vue&type=script&lang=js"
export * from "./ModalDetallesSolicitudesPagosAgrupados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports